import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingShrinkImageOnlineConfig } from '@/data/landingConfig/landingShrinkImageOnlineConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_ShrinkImageOnline } from './schemaObject';

interface Props {}
const ShrinkImageOnline: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_ShrinkImageOnline} />
			<LandingTemplate
				data={landingShrinkImageOnlineConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageCompressor()}
			/>
		</>
	);
};

export default ShrinkImageOnline;
